export default __webpack_public_path__ + "static/media/ooopener-yellow.c5037065.svg";